import React from 'react';

import MuiAccordionActions, {
  AccordionActionsProps as MuiAccordionActionsProps,
} from '@mui/material/AccordionActions';
import clsx from 'clsx';

import { CoreProps } from '../../types';
import { withCoreProps } from '../../withCoreProps';

export const AccordionActions = withCoreProps<AccordionActionsProps>(
  ({
    children,
    className,
    ...props
  }: React.PropsWithChildren<AccordionActionsProps>) => {
    const clsxClass = clsx(className);

    return (
      <MuiAccordionActions {...props} className={clsxClass}>
        {children}
      </MuiAccordionActions>
    );
  },
);

export interface AccordionActionsProps
  extends MuiAccordionActionsProps,
    CoreProps {}
